<div class="flex flex-column gap-3 align-self-stretch pb-4">
  <fieldset class="sps-fieldset form-data-container separator">
    <div class="grid w-full">
      <div class="col-3 flex flex-column gap-2">
        <label for="organisationId">{{ i18n.i18nLng()['MERCHANTID'] }}</label>
        <input pInputText id="organisationId" [value]="organisationData?.displayCustomerNumber" [disabled]="true" pSize="large"/>
      </div>
      <div class="col-9 flex flex-column gap-2">
        <label for="organame">{{ i18n.i18nLng()['ORGANAMESHORT'] }}</label>
        <input pInputText id="organame" [value]="organisationData?.name" [disabled]="true" pSize="large"/>
      </div>
    </div>
  </fieldset>
  <fieldset class="sps-fieldset form-data-container separator">
    <div class="grid w-full">
      <div class="col-6 flex flex-column gap-2">
        <label for="customertype">
          {{ i18n.i18nLng()['CUSTOMERTYPE'] }}<sup class="sps-sup">*</sup>
        </label>
        <p-select [(ngModel)]="organisationData.customerType"
                  inputId="customertype"
                  [options]="settingsProvider.customerType"
                  [showClear]="false"
                  [placeholder]="i18n.i18nLng()['PLACEHOLDERSELECT']"
                  (ngModelChange)="checkCustomerType()"
                  optionLabel="label"
                  optionValue="value"
                  class="w-full"
                  size="large"
                  appendTo="body"
                  [attr.aria-label]="i18n.i18nLng()['CUSTOMERTYPE']"
                  [attr.aria-invalid]="organisationDataInvalidFlags?.customerType"
                  [attr.aria-describedby]="organisationDataInvalidFlags?.customerType ? 'customer-type-invalid-help' : null"
                  [ngClass]="organisationDataInvalidFlags?.customerType ? 'ng-invalid ng-dirty' : null"/>
        @if (organisationDataInvalidFlags?.customerType) {
          <small style="line-height: 1.5rem" class="text-error" role="alert" id="customer-type-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
        }
      </div>
      <div class="col-6 flex flex-column gap-2">
        <label for="organisationtype">
          {{ i18n.i18nLng()['ORGANIZATIONTYPE'] }}<sup class="sps-sup">*</sup>
        </label>
        <p-select [(ngModel)]="organisationData.organisationType"
                  inputId="organisationtype"
                  [options]="settingsProvider.organizationType"
                  [showClear]="false"
                  [placeholder]="i18n.i18nLng()['PLACEHOLDERSELECT']"
                  (ngModelChange)="validateData()"
                  optionLabel="label"
                  optionValue="value"
                  class="w-full"
                  size="large"
                  appendTo="body"
                  [attr.aria-label]="i18n.i18nLng()['ORGANIZATIONTYPE']"
                  [attr.aria-invalid]="organisationDataInvalidFlags?.organisationType"
                  [attr.aria-describedby]="organisationDataInvalidFlags?.organisationType ? 'organisation-type-invalid-help' : null"
                  [ngClass]="organisationDataInvalidFlags?.organisationType ? 'ng-invalid ng-dirty' : null"/>
        @if (organisationDataInvalidFlags?.organisationType) {
          <small style="line-height: 1.5rem" class="text-error" role="alert" id="organisation-type-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
        }
      </div>
      <div class="col-6 flex flex-column gap-2">
        <label for="legal-form">
          {{ i18n.i18nLng()['LEGALFORMLABEL'] }}
        </label>
        <p-select [(ngModel)]="organisationData.legalForm"
                  inputId="legal-form"
                  [options]="settingsProvider.legalForm"
                  [showClear]="true"
                  [placeholder]="i18n.i18nLng()['PLACEHOLDERSELECT']"
                  (ngModelChange)="validateData()"
                  [filter]="true"
                  filterBy="label"
                  optionLabel="label"
                  optionValue="value"
                  class="w-full"
                  size="large"
                  appendTo="body"
                  [attr.aria-label]="i18n.i18nLng()['LEGALFORMLABEL']"/>
      </div>
      <div class="col-6 flex flex-column gap-2">
        <label for="sapId">{{ i18n.i18nLng()['SAPMERCHANTID'] }}</label>
        <input pInputText id="sapId"
               [value]="organisationData?.sapCustomerNumber"
               [disabled]="true"
               pSize="large"/>
      </div>
    </div>
  </fieldset>
  <fieldset class="sps-fieldset form-data-container separator">
    <div class="grid w-full">
      <div class="col-6 flex flex-column gap-2">
        <label for="street-nr">{{ i18n.i18nLng()['STREETNR'] }}<sup class="sps-sup">*</sup></label>
        <input pInputText
               id="street-nr"
               maxlength="100"
               [(ngModel)]="organisationData.streetNr"
               [required]="true"
               [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
               (ngModelChange)="validateData()"
               [ngClass]="organisationDataInvalidFlags?.streetNr ? 'ng-invalid ng-dirty' : null"
               [attr.aria-invalid]="organisationDataInvalidFlags?.streetNr"
               [attr.aria-describedby]="organisationDataInvalidFlags?.streetNr ? 'street-nr-invalid-help' : null"
               pSize="large"/>
        @if (organisationDataInvalidFlags?.streetNr) {
          <small style="line-height: 1.5rem" class="text-error" role="alert" id="street-nr-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
        }
      </div>
      <div class="col-6 flex flex-column gap-2">
        <label for="address-line-2">{{ i18n.i18nLng()['ADDRESS2LABEL'] }}</label>
        <input pInputText
               id="address-line-2"
               maxlength="70"
               [(ngModel)]="organisationData.addressLine2"
               [required]="false"
               [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
               (ngModelChange)="validateData()"
               pSize="large"/>
      </div>
      <div class="col-6 flex flex-column gap-2">
        <label for="postal-code">{{ i18n.i18nLng()['POSTALCODE'] }}<sup class="sps-sup">*</sup></label>
        <p-inputmask
            inputId="postal-code"
            [(ngModel)]="organisationData.postalCode"
            [autoClear]="false"
            styleClass="w-full"
            mask="99999"
            slotChar=""
            [required]="true"
            [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
            (ngModelChange)="validateData()"
            [attr.aria-invalid]="organisationDataInvalidFlags?.postalCode"
            [attr.aria-describedby]="organisationDataInvalidFlags?.postalCode ? 'postal-code-invalid-help' : null"
            [ngClass]="organisationDataInvalidFlags?.postalCode ? 'ng-invalid ng-dirty' : null"
            size="large"/>
        @if (organisationDataInvalidFlags?.postalCode) {
          <small style="line-height: 1.5rem" class="text-error" role="alert" id="postal-code-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
        }
      </div>
      <div class="col-6 flex flex-column gap-2">
        <label for="city">{{ i18n.i18nLng()['CITY'] }}<sup class="sps-sup">*</sup></label>
        <input pInputText
               id="city"
               maxlength="70"
               [(ngModel)]="organisationData.city"
               [required]="true"
               [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
               (ngModelChange)="validateData()"
               [ngClass]="organisationDataInvalidFlags?.city ? 'ng-invalid ng-dirty' : null"
               [attr.aria-invalid]="organisationDataInvalidFlags?.city"
               [attr.aria-describedby]="organisationDataInvalidFlags?.city ? 'city-invalid-help' : null"
               pSize="large"/>
        @if (organisationDataInvalidFlags?.city) {
          <small style="line-height: 1.5rem" class="text-error" role="alert" id="city-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
        }
      </div>
      <!-- Kein Pflichtfeld mehr, Anforderung vom 21.10.2026
      <div class="col-6 flex flex-column gap-2">
        <label for="email">{{ i18n.i18nLng()['EMAILADDRESS'] }}<sup class="sps-sup">*</sup></label>
        <input pInputText
               id="email"
               maxlength="255"
               [(ngModel)]="organisationData.email"
               [required]="true"
               [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
               (ngModelChange)="validateData()"
               [ngClass]="organisationDataInvalidFlags?.email ? 'ng-invalid ng-dirty' : null"
               [attr.aria-invalid]="organisationDataInvalidFlags?.email"
               [attr.aria-describedby]="organisationDataInvalidFlags?.email ? 'email-invalid-help' : null"
               pSize="large"/>
        @if (organisationDataInvalidFlags?.email) {
          <small style="line-height: 1.5rem" class="text-error" role="alert" id="email-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
        }
      </div>
      -->
      <div class="col-6 flex flex-column gap-2">
        <label for="email">{{ i18n.i18nLng()['EMAILADDRESS'] }}</label>
        <input pInputText
               id="email"
               maxlength="255"
               [(ngModel)]="organisationData.email"
               [required]="false"
               [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
               (ngModelChange)="validateData()"
               pSize="large"/>
      </div>
      <div class="col-6 flex flex-column gap-2">
        <label for="phone">{{ i18n.i18nLng()['PHONE'] }}</label>
        <input pInputText
               id="phone"
               maxlength="30"
               [(ngModel)]="organisationData.phone"
               [required]="false"
               [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
               (ngModelChange)="validateData()"
               pSize="large"/>
      </div>
      <div class="col-6 flex flex-column gap-2">
        <label for="url">{{ i18n.i18nLng()['WEBSITEURL'] }}<sup class="sps-sup">*</sup></label>
        <input pInputText
               id="url"
               maxlength="255"
               [(ngModel)]="organisationData.url"
               [required]="false"
               [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
               (ngModelChange)="validateData()"
               [attr.aria-describedby]="organisationDataInvalidFlags?.websiteUrl ? 'email-invalid-help' : 'url-help'"
               [ngClass]="organisationDataInvalidFlags?.websiteUrl ? 'ng-invalid ng-dirty' : null"
               [attr.aria-invalid]="organisationDataInvalidFlags?.websiteUrl"
               pSize="large"/>
        @if (organisationDataInvalidFlags?.websiteUrl) {
          <small style="line-height: 1.5rem" class="text-error" role="alert" id="url-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
        } @else {
          <small style="line-height: 1.5rem" role="contentinfo" id="url-help">{{ i18n.i18nLng()['WEBSITEURLINFOSHORT'] }}</small>
        }
      </div>
      <div class="col-6 flex flex-row gap-2 align-items-center">
        @if (organisationData.customerType !== CustomerType.KOMMUNE) {
          <p-checkbox inputId="is-referral-partner"
                      [(ngModel)]="organisationData.isReferralPartner"
                      (ngModelChange)="validateData()"
                      [binary]="true" size="large"/>
          <label for="is-referral-partner" class="text-lg">{{ i18n.i18nLng()['ISREFERRALPARTNER'] }}</label>
        }
      </div>
    </div>
  </fieldset>
  <fieldset class="sps-fieldset form-data-container separator">
    <div class="grid w-full">
      <div class="col-6 flex flex-column gap-2">
        <label for="bank">
          {{ i18n.i18nLng()['SAVINGBANK'] }}
        </label>
        <p-select [(ngModel)]="organisationData.bankId"
                  inputId="bank"
                  [options]="organisationBankList"
                  [showClear]="true"
                  [placeholder]="i18n.i18nLng()['PLACEHOLDERSELECT']"
                  (ngModelChange)="validateData()"
                  [filter]="true"
                  filterBy="label"
                  optionLabel="label"
                  optionValue="value"
                  class="w-full"
                  size="large"
                  appendTo="body"
                  [attr.aria-label]="i18n.i18nLng()['SAVINGBANK']"
                  (onClear)="organisationData.bank = null"/>
      </div>
      <div class="col-6 flex flex-column gap-2">
        <label for="data-center">
          {{ i18n.i18nLng()['DATACENTER'] }}
        </label>
        <p-select [(ngModel)]="organisationData.dataCenterId"
                  inputId="data-center"
                  [options]="organisationRzList"
                  [showClear]="true"
                  [placeholder]="i18n.i18nLng()['PLACEHOLDERSELECT']"
                  (ngModelChange)="validateData()"
                  [filter]="true"
                  filterBy="label"
                  optionLabel="label"
                  optionValue="value"
                  class="w-full"
                  size="large"
                  appendTo="body"
                  [attr.aria-label]="i18n.i18nLng()['DATACENTER']"
                  (onClear)="organisationData.dataCenter = null"/>
      </div>
      <div class="col-6 flex flex-column gap-2">
        <label for="referral-partner">
          {{ i18n.i18nLng()['REFERRALPARTNER'] }}
        </label>
        <p-select [(ngModel)]="organisationData.referralPartnerId"
                  inputId="referral-partner"
                  [options]="referralPartnerList"
                  [showClear]="true"
                  [placeholder]="i18n.i18nLng()['PLACEHOLDERSELECT']"
                  (ngModelChange)="validateData()"
                  [filter]="true"
                  filterBy="label"
                  optionLabel="label"
                  optionValue="value"
                  class="w-full"
                  size="large"
                  appendTo="body"
                  [attr.aria-label]="i18n.i18nLng()['REFERRALPARTNER']"
                  (onClear)="organisationData.referralPartner = null"/>
      </div>
      <div class="col-6 flex flex-column gap-2">
        <label for="epaybl">
          {{ i18n.i18nLng()['EPAYBL'] }}
        </label>
        <p-select [(ngModel)]="organisationData.ePayBLHeadOffice"
                  inputId="epaybl"
                  [options]="settingsProvider.ePayBL"
                  [showClear]="true"
                  [placeholder]="i18n.i18nLng()['PLACEHOLDERSELECT']"
                  (ngModelChange)="validateData()"
                  [filter]="true"
                  filterBy="label"
                  optionLabel="label"
                  optionValue="value"
                  class="w-full"
                  size="large"
                  appendTo="body"
                  [attr.aria-label]="i18n.i18nLng()['EPAYBL']"/>
      </div>
      <div class="col-6 flex flex-column gap-2">
        <label for="tax-number">{{ i18n.i18nLng()['TAXNUMBER'] }}</label>
        <input pInputText
               id="tax-number"
               maxlength="14"
               [(ngModel)]="organisationData.taxNumber"
               [required]="false"
               [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
               (ngModelChange)="validateData()"
               pSize="large"/>
      </div>
      <div class="col-6 flex flex-column gap-2">
        <label for="register-number">{{ i18n.i18nLng()['REGISTERNUMBER'] }}</label>
        <input pInputText
               id="register-number"
               maxlength="20"
               [(ngModel)]="organisationData.identifier"
               [required]="false"
               [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
               (ngModelChange)="validateData()"
               pSize="large"/>
      </div>
      <div class="col-6 flex flex-column gap-2">
        <label for="vat-id">{{ i18n.i18nLng()['VATID'] }}</label>
        <p-inputmask
            [styleClass]="organisationData?.vatId && organisationData?.vatId.length > 0 ? 'w-full uppercase' : 'w-full'"
            inputId="vat-id"
            [ariaLabel]="i18n.i18nLng()['VATID']"
            [(ngModel)]="organisationData.vatId"
            [autoClear]="false"
            mask="DE999999999"
            slotChar=""
            [required]="false"
            [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
            [attr.aria-invalid]="showInvalidVatId"
            [attr.aria-describedby]="organisationDataInvalidFlags.vatId ? 'vat-id-invalid-help' : null"
            [ngClass]="organisationDataInvalidFlags?.vatId ? 'ng-invalid ng-dirty' : null"
            (onComplete)="checkVatId()"
            size="large"/>
        @if (showInvalidVatId) {
          <small style="line-height: 1.5rem" class="text-error" role="alert" id="vat-id-invalid-help">{{ i18n.i18nLng()['INVALIDVATIDHELP'] }}</small>
        }
      </div>
      <div class="col-6 flex flex-column gap-2">
        <label for="creditor-id">{{ i18n.i18nLng()['CREDITORID'] }}</label>
        <p-inputmask
            [styleClass]="organisationData?.creditorId && organisationData?.creditorId.length > 0 ? 'w-full uppercase' : 'w-full'"
            inputId="creditor-id"
            [ariaLabel]="i18n.i18nLng()['CREDITORID']"
            [(ngModel)]="organisationData.creditorId"
            [autoClear]="false"
            mask="DE99aaa***********"
            slotChar=""
            [required]="false"
            [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
            [attr.aria-invalid]="showInvalidCreditorId"
            [attr.aria-describedby]="organisationDataInvalidFlags.creditorId ? 'creditor-id-invalid-help' : null"
            [ngClass]="organisationDataInvalidFlags?.creditorId ? 'ng-invalid ng-dirty' : null"
            (onComplete)="checkCreditorId()"
            size="large"/>
        @if (showInvalidCreditorId) {
          <small style="line-height: 1.5rem" class="text-error" role="alert" id="creditor-id-invalid-help">{{ i18n.i18nLng()['INVALIDCREDITORIDHELP'] }}</small>
        }
      </div>
      <!--
      <div class="col-6 flex flex-row gap-2 align-items-center">
        <p-checkbox inputId="sid-customer"
                    [(ngModel)]="organisationData.sidClient"
                    (ngModelChange)="validateData()"
                    [binary]="true" size="large"/>
        <label for="sid-customer" class="text-lg">{{ i18n.i18nLng()['SIDCUSTOMER'] }}</label>
      </div>
      -->
      <div class="col-6 flex flex-column gap-2">
        <label for="customergroup">
          {{ i18n.i18nLng()['CUSTOMERGROUP'] }}<sup class="sps-sup">*</sup>
        </label>
        <p-select [(ngModel)]="organisationData.customerGroup"
                  inputId="customergroup"
                  [options]="settingsProvider.customerGroup"
                  [showClear]="false"
                  [placeholder]="i18n.i18nLng()['PLACEHOLDERSELECT']"
                  (ngModelChange)="validateData()"
                  optionLabel="label"
                  optionValue="value"
                  class="w-full"
                  size="large"
                  appendTo="body"
                  [attr.aria-label]="i18n.i18nLng()['CUSTOMERGROUP']"
                  [attr.aria-invalid]="organisationDataInvalidFlags?.customerGroup"
                  [attr.aria-describedby]="organisationDataInvalidFlags?.customerGroup ? 'customer-group-invalid-help' : null"
                  [ngClass]="organisationDataInvalidFlags?.customerGroup ? 'ng-invalid ng-dirty' : null"/>
        @if (organisationDataInvalidFlags?.customerGroup) {
          <small style="line-height: 1.5rem" class="text-error" role="alert" id="customer-group-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
        }
      </div>
      <div class="col-6 flex flex-row gap-2 align-items-center mt-4">
        <p-checkbox inputId="billable"
                    [(ngModel)]="organisationData.billable"
                    (ngModelChange)="validateData()"
                    [binary]="true" size="large"/>
        <label for="billable" class="text-lg">{{ i18n.i18nLng()['BILLABLE'] }}</label>
      </div>
      <div class="col-6 flex flex-column gap-2">
        <label for="paymentmethod">
          {{ i18n.i18nLng()['CUSTOMERPAYMENTMETHOD'] }}<sup class="sps-sup">*</sup>
        </label>
        <p-select [(ngModel)]="organisationData.paymentMethod"
                  inputId="paymentmethod"
                  [options]="settingsProvider.customerPaymentMethod"
                  [showClear]="false"
                  [placeholder]="i18n.i18nLng()['PLACEHOLDERSELECT']"
                  (ngModelChange)="validateData()"
                  optionLabel="label"
                  optionValue="value"
                  class="w-full"
                  size="large"
                  appendTo="body"
                  [attr.aria-label]="i18n.i18nLng()['CUSTOMERPAYMENTMETHOD']"
                  [attr.aria-invalid]="organisationDataInvalidFlags?.paymentMethod"
                  [attr.aria-describedby]="organisationDataInvalidFlags?.paymentMethod ? 'payment-method-invalid-help' : null"
                  [ngClass]="organisationDataInvalidFlags?.paymentMethod ? 'ng-invalid ng-dirty' : null"/>
        @if (organisationDataInvalidFlags?.paymentMethod) {
          <small style="line-height: 1.5rem" class="text-error" role="alert" id="payment-method-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
        }
      </div>
      @if (organisationData?.paymentMethod === 'CUSTOMERPAYMENTDIRECTDEBIT') {
        <div class="col-6 flex flex-column gap-2">
          <label for="mandatereference">{{ i18n.i18nLng()['MANDATEREFERENCE'] }}<sup class="sps-sup">*</sup></label>
          <p-inputmask
              inputId="postal-code"
              [(ngModel)]="organisationData.mandateReference"
              [autoClear]="false"
              [maxlength]="20"
              styleClass="w-full"
              mask="a?aaaaaaaaaaaaaaaaaaa"
              characterPattern="[0-9\-]"
              slotChar=""
              [required]="true"
              [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
              (ngModelChange)="validateData()"
              [attr.aria-invalid]="organisationDataInvalidFlags?.mandateReference"
              [attr.aria-describedby]="organisationDataInvalidFlags?.mandateReference ? 'mandate-reference-invalid-help' : null"
              [ngClass]="organisationDataInvalidFlags?.mandateReference ? 'ng-invalid ng-dirty' : null"
              size="large"/>
          @if (organisationDataInvalidFlags?.mandateReference) {
            <small style="line-height: 1.5rem" class="text-error" role="alert" id="mandate-reference-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
          }
        </div>
      }
    </div>
  </fieldset>
</div>

